import { useRouter } from "next/router";
import {
  AddOnCardBottomContainer,
  AddOnCardBottonText,
  AddOnCardButton,
  AddOnCardWrapper,
  CardHeading,
  CardSubHeading,
  CardTag,
  OptionsLabel
} from "./styles";
import React, { Children, useEffect, useState } from "react";
import { handleUpdateAddonAndUpdateProps } from "@actions/handleAddonUpdate";
import { BasicLoader } from "@acko-tech/building-blocks.ui.loaders";
import CloneChildren from "@components/children";
import DOMPurify from "isomorphic-dompurify";
import { useOnload } from "@utils/useOnLoad";
import { Box } from "@acko-tech/building-blocks.ui.common";
import {
  getWidgetSpecificIsVisible,
  getWidgetSpecificProp
} from "@utils/index";
import { connect } from "react-redux";
import Badge from "@components/common/badge";

interface Props {
  cardHeading: string;
  cardSubHeading: string;
  addAddOnText: string;
  addonAddedText: string;
  priceInfo: string;
  priceInfoVariants?: any;
  tagText?: string;
  badge?: any;
  isSelected: boolean;
  benefits?: any;
  actions: any;
  variantsLength: any;
  children: any;
  is_visible: boolean;
  id: string;
  addonId?: string;
  isAccessory?: boolean;
  isFreeAddon?: boolean;
  displayNetPremium?: any;
  accessoryPriceInfo?: any;
}

const mapStateToProps = function (state: any, ownProps: any) {
  return {
    is_visible: getWidgetSpecificIsVisible(
      state.configuration?.normalisedConfig,
      ownProps.id
    ),
    isSelected: getWidgetSpecificProp(
      state.configuration?.normalisedConfig,
      ownProps.id,
      "isSelected"
    )
  };
};

const AddOnCard = ({ children, ...props }: Props) => {
  const {
    cardHeading,
    cardSubHeading,
    addAddOnText,
    addonAddedText,
    priceInfo,
    priceInfoVariants,
    tagText,
    badge,
    isSelected,
    benefits,
    actions,
    variantsLength,
    is_visible,
    id,
    addonId,
    isAccessory,
    isFreeAddon,
    displayNetPremium,
    accessoryPriceInfo
  } = props;
  const {
    on_click,
    on_click_variants,
    on_add_accessory,
    on_update_accessory,
    on_load
  } = actions || {};
  const router = useRouter();
  const { proposal_ekey } = router.query;
  const [isLoading, setIsLoading] = useState(false);
  const [isUserApplied, setisUserApplied] = useState(false);
  useOnload({ on_load });

  useEffect(() => {
    setisUserApplied(!!isSelected);
  }, [isSelected]);

  const handleAddonUpdate = async () => {
    if (variantsLength) {
      const openVaritantModal = on_click_variants?.[0];
      if (
        openVaritantModal &&
        typeof openVaritantModal.funCall === "function"
      ) {
        openVaritantModal.funCall(openVaritantModal.args || {});
      }
    } else if (isAccessory) {
      if (isSelected) {
        if (on_update_accessory?.length > 0) {
          on_update_accessory?.forEach((eachFunc: any) => {
            typeof eachFunc.funCall === "function" &&
              eachFunc.funCall(eachFunc.args);
          });
        }
      } else {
        if (on_add_accessory?.length > 0) {
          on_add_accessory?.forEach((eachFunc: any) => {
            typeof eachFunc.funCall === "function" &&
              eachFunc.funCall(eachFunc.args);
          });
        }
      }
    } else {
      await handleUpdateAddonAndUpdateProps(
        isUserApplied,
        setIsLoading,
        proposal_ekey,
        on_click,
        setisUserApplied,
        id
      );
    }
  };

  if (!is_visible) {
    return null;
  }

  const addonPriceInfo =
    addonId === "pa_owner_car" && isFreeAddon
      ? '15L Personal Accident Cover for <span class="free-addon-label">Free</span>'
      : isAccessory && displayNetPremium === "0"
      ? accessoryPriceInfo
      : variantsLength > 1
        ? priceInfoVariants
        : priceInfo;

  return (
    <Box>
      {isLoading ? <BasicLoader /> : null}
      <AddOnCardWrapper>
        <CardHeading>
          {badge?.text && (
            <Badge
              is_visible
              text={badge?.text}
              type={badge?.type}
              styles={{ marginBottom: "1rem" }}
            />
          )}
          {cardHeading}
        </CardHeading>
        <CardSubHeading
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(cardSubHeading)
          }}
        ></CardSubHeading>

        <AddOnCardBottomContainer>
          <AddOnCardBottonText
            dangerouslySetInnerHTML={{
              __html: addonPriceInfo
            }}
          ></AddOnCardBottonText>
          <AddOnCardButton
            onClick={handleAddonUpdate}
            isSelected={isUserApplied}
          >
            {isUserApplied ? addonAddedText : addAddOnText}
            {variantsLength && !isUserApplied ? (
              <OptionsLabel>2 options</OptionsLabel>
            ) : (
              ""
            )}
          </AddOnCardButton>
        </AddOnCardBottomContainer>
      </AddOnCardWrapper>
      <CloneChildren
        styles={{ gap: "0px" }}
        children={children}
        props={{ ...props, isUserApplied }}
      />
    </Box>
  );
};

export default connect(mapStateToProps)(AddOnCard);
